import React from 'react'
import { Element, Icon } from 'react-bulma-components'

/**
 * Props for the OverlayLoader component
 */
export interface OverlayLoaderProps {
  /** Whether the loader is visible */
  isLoading: boolean
  /** Optional text to display below the spinner */
  text?: string
  /** Optional custom CSS class */
  className?: string
}

/**
 * Full-screen overlay loader component
 * Covers the entire application with a semi-transparent background
 * and displays a centered loading spinner with optional text
 * Uses only React Bulma components and utility classes
 */
const OverlayLoader: React.FunctionComponent<OverlayLoaderProps> = ({
  isLoading,
  text = 'Chargement...',
  className = '',
}) => {
  if (!isLoading) {
    return null
  }

  return (
    <Element
      className={`is-overlay ${className}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
      }}
    >
      <Element
        className="has-text-centered"
        style={{
          minWidth: '200px',
          minHeight: '150px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}
      >
        {/* Spinner container */}
        <div className="mb-4">
          <Icon size="large" className="has-text-primary">
            <i className="fas fa-spinner fa-spin" />
          </Icon>
        </div>

        {/* Loading text */}
        {text && (
          <Element className="has-text-weight-medium" textSize={5} textColor="white">
            {text}
          </Element>
        )}
      </Element>
    </Element>
  )
}

export default OverlayLoader
